module.exports = __webpack_public_path__ + "static/giraffeanimal3-d82b108e9258c13b9aa777509baaeb19.png";